import { GraphCMSQueryDef } from "@mywheels/common/lib/useGraphCMS";

export type WebHandleidingCar = {
  id: string;
  youtubeId: string;
  manualSections: Array<{
    id: string;
    name: string;
    slug: string;
    icon?: {
      name: string;
      data: unknown;
    };
  }>;
};

export const GetWebHandleidingCarQuery: GraphCMSQueryDef<
  WebHandleidingCar,
  { slug: string; locale: string }
> = {
  key: "car",
  query: `
  query GetCarManualSectionsQuery($slug: String!, $locale: Locale!) {
    car(where: { slug: $slug }) {
      id
      youtubeId
      manualSections(locales: [$locale]) {
        id
        name
        slug
        icon {
          name
          data
        }
      }
    }
  }
`,
};
